import { render, staticRenderFns } from "./select-penatly-reason.vue?vue&type=template&id=9d3a912a&"
import script from "./select-penatly-reason.vue?vue&type=script&lang=js&"
export * from "./select-penatly-reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports